import React from 'react';
import { STONES_PER_PLAYER, INITIAL_TIME } from '../constants';
import player1Image from '../assets/images/player_1.png';
import player2Image from '../assets/images/player_2.png';
import playerRandomImage from '../assets/images/player_random.png';
import { gameStyles } from '../styles/gameStyles';

const Players = ({
  gameMode,
  currentPlayer,
  playerColor,
  stonesPlaced,
  timeLeft,
  gameOver,
  winner,
  scores,
  className,
  aiType,
  currentStyle = 'classic',
}) => {
  const styles = gameStyles[currentStyle];

  const getPlayerName = (color) => {
    if (gameMode === 'ai') {
      return playerColor === color ? 'Player' : aiType === 'random' ? 'Doge' : 'Casual Gamer';
    }

    return color === 'black' ? 'Player 1' : 'Player 2';
  };

  const getPlayerImage = (color) => {
    if (gameMode === 'ai') {
      if (color === playerColor) return player1Image;

      return aiType === 'random' ? playerRandomImage : player2Image;
    }
    return color === 'black' ? player1Image : player2Image;
  };

  const renderStonesLeft = (color) => {
    const stonesLeft = STONES_PER_PLAYER - stonesPlaced[color];
    return (
      <div className="flex gap-1">
        {Array(stonesLeft).fill(null).map((_, index) => (
          <div
            key={index}
            className={`
              w-3 h-3 rounded-full shadow-sm
              ${color === 'black'
                ? `${styles.firstStoneColor} ${styles.firstStoneShadowOnDark}`
                : `${styles.secondStoneColor} ${styles.secondStoneShadowOnDark}`
              }
            `}
          />
        ))}
      </div>
    );
  };

  const renderTimer = (color) => {
    if (currentPlayer !== color || gameOver) return null;

    const circumference = 2 * Math.PI * 20 // radius = 20
    const strokeDashoffset = circumference * (1 - timeLeft / INITIAL_TIME)

    return (
      <>
        {/* Circular timer for larger screens */}
        <div className={`relative w-12 h-12 opacity-0 sm:opacity-100`}>
          <svg className="w-full h-full -rotate-90">
            <circle
              cx="24"
              cy="24"
              r="20"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              className="text-gray-700"
            />
            <circle
              cx="24"
              cy="24"
              r="20"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              className="text-white"
            />
          </svg>
          <span className="absolute inset-0 flex items-center justify-center text-sm">
            {timeLeft}
          </span>
        </div>
        {/* Linear timer bar for small screens */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-700 sm:hidden">
          <div
            className="h-full bg-white transition-all duration-1000 ease-linear"
            style={{
              width: `${Math.max(0, (timeLeft / INITIAL_TIME) * 100)}%`,
              transform: `translateX(${timeLeft === 0 ? '100%' : '0'})`
            }}
          />
        </div>
      </>
    );
  };

  return (
    <div className={`flex justify-between w-full sm:px-16 max-w-2xl mb-4 sm:mr-14 ${className}`}>
      {['black', 'white'].map((color) => (
        <div
          key={color}
          className={`flex items-center sm:gap-4 py-2 px-3 sm:p-4 rounded-lg relative ${gameOver
            ? winner === color
              ? 'bg-green-900'
              : winner === 'draw'
                ? 'bg-gray-800'
                : 'bg-gray-800 opacity-50'
            : currentPlayer === color
              ? 'bg-gray-800'
              : 'bg-gray-900'
            }`}
        >
          <div className="flex items-center gap-4">
            <img
              src={getPlayerImage(color)}
              alt={getPlayerName(color)}
              className="w-12 h-12 rounded-full"
            />
            <div className="flex flex-col gap-1">
              <span className="font-bold text-xs sm:text-base">{getPlayerName(color)}</span>
              {renderStonesLeft(color)}
              {gameOver && scores && (
                <div className="font-bold text-xs sm:text-xl">
                  {scores[color]} pts
                </div>
              )}
            </div>
          </div>
          {renderTimer(color)}
        </div>
      ))}
    </div>
  );
};

export default Players; 
